export const INITIAL_AUTH = "INITIAL_AUTH";
export const GET_ACCESS_TOKEN = "GET_ACCESS_TOKEN";
export const SET_USER = "SET_USER";
export const LOGOUT = "LOGOUT";
